// import {combineReducers} from 'redux'
// import commentsReducer from './comments'
// export default combineReducers({
//     comments:commentsReducer
// })

/**
 * Combine all reducers in this file and export the combined reducers.
 */

import { combineReducers } from "redux";
import globalReducer from "./global";
import languageProviderReducer from "containers/LanguageProvider/reducer";
import quickOrderReducer from "screens/QuickOrder/quickOrderSlice";
import orderCheckerReducer from "screens/OrderChecker/orderCheckerSlice";
import appRootReducer from "AppRoot/reducer";

/**
 * Merges the main reducer with dynamically injected reducers
 */
export default function createReducer(injectedReducers = {}) {
  const rootReducer = combineReducers({
    global: globalReducer,
    language: languageProviderReducer,
    quickOrder: quickOrderReducer,
    orderChecker: orderCheckerReducer,
    appRoot: appRootReducer,
    ...injectedReducers,
  });

  return rootReducer;
}
